{register} = require 'src/js/infrastructure/setup-registry'

setup = ($ctx, promise) ->
    $grid = $ctx.find('#licences').staticgrid()[0]
    entityId = $ctx.find('#EntityId').val()
    $grid.options.ajax.payload = -> {entityId}

register('App.RTK.Administration.MyLicensesForEntity.Setup', setup)